import {Request}                                from "../../../../request.abstract";
import {Observable}                             from "rxjs";
import {ContactMoment, ContactMomentCollection} from "./api.models";
import {Http}                                   from "@angular/http";
import {Settings}                               from '../../../../settings.model';

export class ContactMomentsEndpoint extends Request {
    protected schemaId: number;
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number, schemaId: number) {
        super(http, settings);

        this.baseId   = baseId;
        this.schemaId = schemaId;
    }

    collection(page: number, perPage: number): Observable<ContactMomentCollection> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + this.schemaId + '/contactmoments', this.createSearch({page : page, perPage : perPage}));
    }

    add(contactMoment: ContactMoment): Observable<ContactMoment> {
        return this.post('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + this.schemaId + '/contactmoments', contactMoment);
    }

    update(id: number, contactMoment: ContactMoment): Observable<ContactMoment> {
        return this.patch('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + this.schemaId + '/contactmoments/' + id, contactMoment);
    }

    remove(id: number): Observable<any> {
        return this.delete('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + this.schemaId + '/contactmoments/' + id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/schemas/contactMoments/api.service.ts